export const PROJECT_STATUSES = [
  { key: 'ongoing', label: 'Ongoing', cls: 'st-ongoing' },
  { key: 'quoting', label: 'Quoting', cls: 'st-quoting' },
  { key: 'on_hold', label: 'On Hold', cls: 'st-onhold' },
  { key: 'complete', label: 'Complete', cls: 'st-complete' },
  { key: 'archived', label: 'Archived', cls: 'st-archived' },
];
export const statusMeta = (k) => PROJECT_STATUSES.find(s => s.key === k) || PROJECT_STATUSES[0];
